/* eslint-disable no-param-reassign */
import Sonda from "@gcloud-npm/bit.utils.front-sonda";
import {
  moduloCabeceras,
  moduloSectionImage,
  moduloVideoBannerFondosEuropeos,
  moduloHeadingTitle,
  moduloVentajasSolucionesDigitales,
  moduloBannerHablaConExperto,
  moduloFraseDestacada,
  moduloPorcentajes,
  moduloFAQ,
  moduloImageCircle,
  moduloFourKeys,
  moduloDiezNecesidades,
  moduloTitle,
  moduloCircleList,
} from "../../utils/normalizerModules.utils";
import { createSondaContext } from "../../utils/contextUtils";
import { MODULES } from "../../constants/modulesNames";

/**
 * Normaliza los fusiones que vienen desde catálogo a una estructura válida
 * @param {Object[]} expertList - lista de los fusiones que viene desde catálogo
 * @returns {Object[]} - lista de fusiones normalizados
 */
export const normalizeExpert = (expertList) => {
  const context = createSondaContext("empresas");
  const sonda = new Sonda({
    processName: "normalizeModulesOfExpert",
    context,
    filePath: "sagas/normalizers/expert",
  });
  if (!expertList) {
    sonda.severalMessage({ info: "expertList doesn´t exist" });
    return null;
  }
  let modulesToArray = [];

  if (!Array.isArray(expertList)) {
    expertList = [expertList];
  }

  try {
    // Aqui lo que hacemos es recorrer la lista de modulos, y pasarlos por sus normalizadores
    modulesToArray = expertList.reduce((arr, currentModule) => {
      Object.values(currentModule.data.fields).map((item) => {
        switch (item.name) {
          case MODULES.MODULO_CABECERAS_SOLUCIONES_DIGITALES:
            item.fields = moduloCabeceras(item.fields);
            break;
          case MODULES.MODULO_H2_TITLE:
            item.fields = moduloHeadingTitle(item.fields);
            break;
          case MODULES.MODULO_VIDEO_SOLUCIONES_DIGITALES:
            item.fields = moduloVideoBannerFondosEuropeos(item.fields);
            break;
          case MODULES.MODULO_INTRODUCCION_SOLUCIONES_DIGITALES:
            item.fields = moduloSectionImage(item.fields);
            break;
          case MODULES.MODULO_TITLE:
            item.fields = moduloTitle(item.fields);
            break;
          case MODULES.MODULO_VENTAJAS_SOLUCIONES_DIGITALES:
            item.fields = moduloVentajasSolucionesDigitales(item.fields);
            break;
          case MODULES.MODULO_BANNER_CTA:
            item.fields = moduloBannerHablaConExperto(item.fields);
            break;
          case MODULES.MODULO_FRASE_DESTACADA:
            item.fields = moduloFraseDestacada(item.fields);
            break;
          case MODULES.MODULO_RESULTADOS_PORCENTAJES:
            item.fields = moduloPorcentajes(item.fields);
            break;
          case MODULES.MODULO_FAQS_PREGUNTAS_FRECUENTES:
            item.fields = moduloFAQ(item);
            break;
          case MODULES.MODULO_IMAGE_CIRCLE:
            item.fields = moduloImageCircle(item);
            break;
          case MODULES.MODULO_CLAVES_LISTADO:
            item.fields = moduloFourKeys(item);
            break;
          case MODULES.MODULO_NECESIDADES:
            item.fields = moduloDiezNecesidades(item);
            break;
          case MODULES.MODULO_CIRCLE_LIST:
            item.fields = moduloCircleList(item);
            break;
          default:
            return null;
        }
        return item;
      });

      arr = [...arr, currentModule];
      return arr;
    }, []);
    return modulesToArray;
  } catch (error) {
    console.log({ error });
    sonda.severalMessage({ error });
    return null;
  }
};
